export class PotentialRecruit {
	userId: number
	phone: string
	expires: string
}